module.exports = __webpack_public_path__ + "media/advantages/advantage-img-2-4b546bd6.png";